import { TenantNotification } from '@api';

export class PushNotifications {
    public static readonly type = '[Notifications] Push notifications';

    constructor(public notifications: TenantNotification[]) {}
}
